/**
 * 行情模块：公开行情 / 价格走势 / 地区均价
 */
import { ApiError, get } from './http';
import { canFallbackToMock } from './errors';
import { mockMarketPrices, mockPriceTrend, mockQuoteStats, mockRegionPrices } from './mock';
import type { MarketPriceItem, PriceTrend, QuoteStats, RegionPriceItem } from '@/types';

/** 公开市场行情（各品种均价）：已接后端 /public/market/price，仅网络/未实现降级 mock */
export async function getMarketPrice(): Promise<MarketPriceItem[]> {
  try {
    const data = await get<MarketPriceItem[]>('/public/market/price');
    return Array.isArray(data) ? data : [];
  } catch (e) {
    if (canFallbackToMock(e)) return mockMarketPrices;
    throw e;
  }
}

/** 价格走势（7/30/90 天）：已接后端 /public/market/price/trend，仅网络/未实现降级 mock */
export async function getPriceTrend(breed: string, days: number): Promise<PriceTrend> {
  try {
    const data = await get<PriceTrend>('/public/market/price/trend', { breed, days });
    if (data && Array.isArray(data.points) && data.points.length > 0) return data;
    // 后端正常返回但无走势数据：如实报错（页面降级为空占位），不伪造 mock 行情
    throw new ApiError(1005, '暂无价格走势数据');
  } catch (e) {
    if (canFallbackToMock(e)) return mockPriceTrend(breed, days);
    throw e;
  }
}

/** 地区均价（热力图降级为表格）：后端无 /analytics/region-distribution，404/网络降级 mock */
export async function getRegionPrices(): Promise<RegionPriceItem[]> {
  try {
    const data = await get<RegionPriceItem[]>('/analytics/region-distribution');
    return Array.isArray(data) ? data : [];
  } catch (e) {
    if (canFallbackToMock(e)) return mockRegionPrices;
    throw e;
  }
}

/** 行情统计卡：接真实后端 /public/market/quote-stats，仅网络错误/404 降级 mock（展示数据，非操作成功态） */
export async function getQuoteStats(): Promise<QuoteStats> {
  try {
    return await get<QuoteStats>('/public/market/quote-stats');
  } catch (e) {
    if (canFallbackToMock(e)) return mockQuoteStats;
    throw e;
  }
}
